import styled from "styled-components/macro";

export const Container = styled.fieldset`
  display: grid;
  grid-template-areas:
    "dateIn dateOut"
    "budget countryWillGo"
    ". cityWillGo";
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, auto);
  #dateIn {
    grid-area: dateIn;
  }
  #dateOut {
    grid-area: dateOut;
  }

  #budget {
    grid-area: budget;
  }

  #countryWillGo {
    grid-area: countryWillGo;
  }

  #cityWillGo {
    grid-area: cityWillGo;
  }
  gap: 24px;
  transition: 0.7s;
  @media ${(props) => props.theme.media.phone} {
    grid-template-areas:
      "dateIn"
      "dateOut"
      "budget"
      "countryWillGo"
      "cityWillGo";
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, auto);
  }
`;
